(function() {
  const STORAGE_KEY = 'pet_name';
  const DEFAULT_ATTRIBUTE_NAME = 'Nombre mascota';

  function getInput() {
    return document.querySelector('[data-pet-name-input]');
  }

  function getAttributeName() {
    const input = getInput();
    const attributeName = input?.dataset.petNameAttribute?.trim();

    return attributeName || DEFAULT_ATTRIBUTE_NAME;
  }

  function cleanValue(value) {
    return String(value || '').trim();
  }

  function getPetName() {
    const input = getInput();
    return cleanValue(input?.value || localStorage.getItem(STORAGE_KEY) || '');
  }

  function setPetName(value) {
    const clean = cleanValue(value);

    if (clean) {
      localStorage.setItem(STORAGE_KEY, clean);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }

    const input = getInput();

    if (input && input.value !== clean) {
      input.value = clean;
    }

    return clean;
  }

  async function syncPetNameToCart() {
    const attributeName = getAttributeName();
    const petName = getPetName();

    const attributes = {};
    attributes[attributeName] = petName;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('No se pudo guardar el nombre de la mascota en el carrito');
    }

    const cart = await response.json();

    console.log('[PetNameAttribute] Cart attributes actualizados:', cart.attributes);

    return cart;
  }

  function initPetNameBlock() {
    const input = getInput();
    if (!input || input.dataset.petNameInitialized === 'true') return;

    input.dataset.petNameInitialized = 'true';

    const savedValue = localStorage.getItem(STORAGE_KEY);

    if (savedValue) {
      input.value = savedValue;
      syncPetNameToCart().catch(console.error);
    }

    let timeout;

    input.addEventListener('input', function(event) {
      setPetName(event.target.value);

      clearTimeout(timeout);

      timeout = setTimeout(function() {
        syncPetNameToCart().catch(console.error);
      }, 400);
    });

    input.addEventListener('change', function(event) {
      setPetName(event.target.value);
      syncPetNameToCart().catch(console.error);
    });

    input.addEventListener('blur', function(event) {
      setPetName(event.target.value);
      syncPetNameToCart().catch(console.error);
    });
  }

  function interceptMainProductForms() {
    document.addEventListener('submit', async function(event) {
      const form = event.target.closest('form[action*="/cart/add"]');

      if (!form) return;
      if (!getInput()) return;
      if (form.dataset.petNameSynced === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        await syncPetNameToCart();

        form.dataset.petNameSynced = 'true';

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }

        setTimeout(function() {
          delete form.dataset.petNameSynced;
        }, 1000);
      } catch (error) {
        console.error('[PetNameAttribute] Error sincronizando antes de add-to-cart:', error);

        delete form.dataset.petNameSynced;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }
    }, true);
  }

  function interceptCheckoutButtons() {
    document.addEventListener('click', async function(event) {
      const checkoutButton = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
      );

      if (!checkoutButton) return;
      if (!getInput()) return;
      if (checkoutButton.dataset.petNameSynced === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        await syncPetNameToCart();

        checkoutButton.dataset.petNameSynced = 'true';
        checkoutButton.click();

        setTimeout(function() {
          delete checkoutButton.dataset.petNameSynced;
        }, 1000);
      } catch (error) {
        console.error('[PetNameAttribute] Error sincronizando antes de checkout:', error);

        delete checkoutButton.dataset.petNameSynced;
        checkoutButton.click();
      }
    }, true);
  }

  window.PetNameAttribute = {
    get: getPetName,
    set: setPetName,
    sync: syncPetNameToCart
  };

  document.addEventListener('DOMContentLoaded', function() {
    initPetNameBlock();
    interceptMainProductForms();
    interceptCheckoutButtons();
  });

  document.addEventListener('shopify:section:load', function() {
    initPetNameBlock();
  });
})();